// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 20px;
  background: #f5f7fb;
  min-height: 100vh;
}

.dashboard-heading {
  font-weight: bold;
  font-size: 25px;
  line-height: 40px;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-top: 20px;
}

.kpi-tile {
  border-radius: 14px;
  padding: 10px;
  min-height: 10px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

.kpi-tile:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.kpi-blue {
  background: #eef4ff;
  border-color: #c7d7fe;
}

.kpi-green {
  background: #edf7ee;
  border-color: #b7e1c1;
}

.kpi-red {
  background: #fdecec;
  border-color: #f5c2c2;
}

.kpi-orange {
  background: #fff4e5;
  border-color: #ffd8a8;
}

.kpi-purple {
  background: #f4efff;
  border-color: #d6c7ff;
}

.kpi-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}

.kpi-icon {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.icon-blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.icon-green {
  background: #d1fae5;
  color: #047857;
}

.icon-red {
  background: #fee2e2;
  color: #b91c1c;
}

.icon-orange {
  background: #ffedd5;
  color: #c2410c;
}

.icon-purple {
  background: #ede9fe;
  color: #6d28d9;
}

.kpi-title {
  font-size: 12px;
  color: #6b7280;
}

.kpi-value {
  font-size: 20px;
  font-weight: 600;
}

.kpi-change {
  font-size: 12px;
  font-weight: 500;
}

.green {
  color: #2e7d32;
}

.red {
  color: #d32f2f;
}

.orange {
  color: #ed6c02;
}

.purple {
  color: #6a1b9a;
}

.blue {
  color: #1565c0;
}

.order-overview {
  background: #ffffff;
  padding: 18px;
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}

.overview-header h3 {
  font-size: 16px;
  font-weight: 600;
}

.date-filter select {
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 13px;
}

.funnel-card {
  position: relative;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid #eef2f7;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.funnel-card p {
  margin: 0;
  font-size: 10px;
  color: #6b7280;
}

.funnel-card span {
  font-size: 20px;
  font-weight: 700;
  margin-top: 6px;
}

.funnel-card:hover {
  transform: translateY(-2px);
}

.funnel-card.blue {
  background: #eef4ff;
  border-right: 3px solid #3b82f6;
}

.funnel-card.orange {
  background: #fff4e5;
  border-right: 3px solid #f59e0b;
}

.funnel-card.purple {
  background: #f4efff;
  border-right: 3px solid #8b5cf6;
}

.funnel-card.green {
  background: #edf7ee;
  border-right: 3px solid #10b981;
}

.funnel-card.red {
  background: #fdecec;
  border-right: 3px solid #ef4444;
}

.funnel-card span {
  display: block;
  font-size: 20px;
  font-weight: 700;
  margin-top: 6px;
}

.funnel-icon {
  margin-top: 10px;
  font-size: 20px;
  opacity: 0.8;
  pointer-events: none;
  padding: 8px;
  border-radius: 100px;
}

.funnel-icon.blue {
  background: white;
  color: #1d4ed8;
}

.funnel-icon.orange {
  background: white;
  color: #c2410c;
}

.funnel-icon.purple {
  background: white;
  color: #6d28d9;
}

.funnel-icon.green {
  background: white;
  color: #047857;
}

.funnel-icon.red {
  background: white;
  color: #b91c1c;
}

.funnel-iconn.blue {
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 20px;
  border-radius: 100px;
  padding: 4px;
}

.funnel-iconn.orange {
  background: #ffedd5;
  color: #c2410c;
  font-size: 20px;
  border-radius: 100px;
  padding: 4px;
}

.funnel-iconn.green {
  background: #d1fae5;
  color: #047857;
  font-size: 20px;
  border-radius: 100px;
  padding: 4px;
}

.funnel-iconn.red {
  width: 25px;
  height: 25px;
  background: white;
  color: #b91c1c;
  font-size: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* .funnel-iconn.red {
  background: white;
  color: #b91c1c;
  font-size: 20px;
  border-radius: 100px;
  padding: 4px;
} */

.progress-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.progress-bar {
  height: 6px;
  background: #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 6px;
}

.metrics-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
}

.metric-box {
  background: #f9fafb;
  padding: 6px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  font-size: 10px;
}

.metric-box.blue {
  background: #f8fafc;
  border-color: #c7d7fe;
}

.metric-box.orange {
  background: #f8fafc;
  border-color: #ffd8a8;
}

.metric-box.green {
  background: #f8fafc;
  border-color: #b7e1c1;
}

.metric-box.red {
  background: #f8fafc;
  border-color: #f5c2c2;
}

.metric-box p {
  padding: 0;
  font-size: 10px;
}

.metric-box strong {
  padding-left: 10px;
  font-size: 16px;
}

.metric-box.highlight {
  background: #fdecec;
  color: #b91c1c;
}

.metric-icon {
  width: 20px;
  height: 20px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  background-color: white;
  color: green;
}

.metric-content {
  padding-left: 0;
}

.dashboard-main {
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 16px;
  margin-top: 20px;
  align-items: start;
}

.left-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.right-panel {
  background: white;
  border-radius: 14px;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  /* min-height: 460px;
  height: 460px; */
  height: 320px;
  min-height: 320px;
  overflow: hidden;
  position: relative;
}

.live-tracking-placeholder {
  height: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-weight: 500;
}

.overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.funnel-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  position: relative;
  gap: 12px;
  margin-bottom: 16px;
}

.funnel-card::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -18px;
  border-left: 6px solid #d1d5db;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transform: translateY(-50%);
}

.funnel-card:last-child::after,
.funnel-card:last-child::before {
  display: none;
}

.alerts-box {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.alerts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.alerts-header h4 {
  font-size: 14px;
  font-weight: 600;
}

.alerts-header span {
  font-size: 12px;
  color: #3b82f6;
  cursor: pointer;
}

.alert-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  border-radius: 10px;
  transition: 0.2s;
}

.alert-item:hover {
  background: #f8fafc;
}

.alert-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.alert-item p {
  font-size: 12px;
  margin: 0;
}

.alert-item strong {
  font-size: 12px;
  background: #fee2e2;
  color: #b91c1c;
  padding: 2px 8px;
  border-radius: 8px;
}

.alert-dot.red {
  background: #ef4444;
  border-width: 1px;
  border-color: #dc2626;
}

.alert-dot.blue {
  background: #3b82f6;
  border-width: 1px;
  border-color: #1d4ed8;
}

.alert-dot.orange {
  background: #ffa200;
  border-width: 1px;
  border-color: #c2410c;
}

.alert-dot.green {
  background: #10b981;
  border-width: 1px;
  border-color: #059669;
}

.alert-dot.purple {
  background: #8b5cf6;
  border-width: 1px;
  border-color: #7c3aed;
}

.alert-dot.yellow {
  background: #f2ff00;
  border-width: 1px;
  border-color: #eab308;
}

.alert-dot.gray {
  background: #6b7280;
  border-width: 1px;
  border-color: #374151;
}

.alert-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 16px;
  margin-left: -10px;
}

.alert-icon.red {
  background: #fee2e2;
  color: #dc2626;
}

.alert-icon.orange {
  background: #ffedd5;
  color: #ea580c;
}

.alert-icon.yellow {
  background: #fef9c3;
  color: #ca8a04;
}

.alert-icon.green {
  background: #dcfce7;
  color: #16a34a;
}

.alert-icon.purple {
  background: #ede9fe;
  color: #7c3aed;
}

.alert-icon.gray {
  background: #f3f4f6;
  color: #4b5563;
}

.drivers-box {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  align-items: center;
}

.drivers-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.drivers-header h4 {
  font-size: 14px;
  font-weight: 600;
}

.drivers-header span {
  font-size: 12px;
  color: #3b82f6;
  cursor: pointer;
}

.drivers-box table {
  width: 100%;
  font-size: 12px;
  border-collapse: collapse;
}

.drivers-box th {
  text-align: center;
  color: #6b7280;
  font-weight: 500;
  padding: 0 8px;
  border-right: 1px dotted #4b4848;
}

.drivers-box .successTH {
  border-right: none;
}

.drivers-box td {
  padding: 10px 0;
  border-top: 1px dotted #4b4848;
}

.drivers-box .dName {
  text-align: left;
  padding-left: 4px;
}

.drivers-box .dNumber {
  text-align: right;
  padding-right: 4px;
  border-left: 1px dotted #4b4848;
}

.drivers-box tr {
  border-bottom: 1px dotted #4b4848;
}

.drivers-box tr:last-child {
  border-bottom: none;
}

.bottom-grid {
  display: grid;
  grid-template-columns: 1.1fr 2fr 1.9fr;
  gap: 16px;
  margin-top: 20px;
}

.chart-box {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.chart-header h4 {
  font-size: 14px;
  font-weight: 600;
}

.chart-header span {
  font-size: 12px;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
}

.driver-card {
  background: white;
  padding: 8px 10px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 12px;
  min-width: 120px;
}

.driver-plate {
  background: #ef4444;
  color: white;
  padding: 4px 6px;
  border-radius: 6px;
  font-weight: 600;
  margin-bottom: 4px;
  text-align: center;
}

.driver-meta {
  color: #555;
  text-align: center;
}

.tracking-card {
  height: 100%;
  min-height: 520px;
  background: white;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.06);
}

.driver-tooltip {
  min-width: 180px;
  border-radius: 16px;
  overflow: hidden;
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.driver-tooltip-header {
  padding: 10px 14px;
  font-weight: 700;
  color: white;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
}

.driver-tooltip-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.driver-tooltip-body div {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.driver-tooltip-body span {
  color: #6b7280;
}

.driver-tooltip-body strong {
  color: #111827;
}

.tracking-header {
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-bottom: 1px solid #f1f5f9;
}

.tracking-header h3 {
  margin: 0;
  font-size: 18px;
}

.tracking-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.live-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-weight: 600;
  font-size: 12px;
}

.live-badge span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
}

/* ── Live Tracking Panel ─────────────────────────────── */
.tracking-header {
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-bottom: 1px solid #f1f5f9;
  height: 58px;
  box-sizing: border-box;
}

.tracking-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.tracking-header p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 12px;
}

.live-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.5px;
}

.live-badge span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  animation: livePulse 1.5s ease-in-out infinite;
}

@keyframes livePulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,0CAA0C;EAC1C;kBACgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EAErC,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF","sourcesContent":[".dashboard-container {\r\n  padding: 20px;\r\n  background: #f5f7fb;\r\n  min-height: 100vh;\r\n}\r\n\r\n.dashboard-heading {\r\n  font-weight: bold;\r\n  font-size: 25px;\r\n  line-height: 40px;\r\n}\r\n\r\n.kpi-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(6, 1fr);\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.kpi-tile {\r\n  border-radius: 14px;\r\n  padding: 10px;\r\n  min-height: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #ffffff;\r\n  border: 1px solid transparent;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.kpi-tile:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.kpi-blue {\r\n  background: #eef4ff;\r\n  border-color: #c7d7fe;\r\n}\r\n\r\n.kpi-green {\r\n  background: #edf7ee;\r\n  border-color: #b7e1c1;\r\n}\r\n\r\n.kpi-red {\r\n  background: #fdecec;\r\n  border-color: #f5c2c2;\r\n}\r\n\r\n.kpi-orange {\r\n  background: #fff4e5;\r\n  border-color: #ffd8a8;\r\n}\r\n\r\n.kpi-purple {\r\n  background: #f4efff;\r\n  border-color: #d6c7ff;\r\n}\r\n\r\n.kpi-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex: 1;\r\n}\r\n\r\n.kpi-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 100px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n}\r\n\r\n.icon-blue {\r\n  background: #dbeafe;\r\n  color: #1d4ed8;\r\n}\r\n\r\n.icon-green {\r\n  background: #d1fae5;\r\n  color: #047857;\r\n}\r\n\r\n.icon-red {\r\n  background: #fee2e2;\r\n  color: #b91c1c;\r\n}\r\n\r\n.icon-orange {\r\n  background: #ffedd5;\r\n  color: #c2410c;\r\n}\r\n\r\n.icon-purple {\r\n  background: #ede9fe;\r\n  color: #6d28d9;\r\n}\r\n\r\n.kpi-title {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.kpi-value {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.kpi-change {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.green {\r\n  color: #2e7d32;\r\n}\r\n\r\n.red {\r\n  color: #d32f2f;\r\n}\r\n\r\n.orange {\r\n  color: #ed6c02;\r\n}\r\n\r\n.purple {\r\n  color: #6a1b9a;\r\n}\r\n\r\n.blue {\r\n  color: #1565c0;\r\n}\r\n\r\n.order-overview {\r\n  background: #ffffff;\r\n  padding: 18px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.overview-header h3 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.date-filter select {\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid #ddd;\r\n  font-size: 13px;\r\n}\r\n\r\n.funnel-card {\r\n  position: relative;\r\n  padding: 10px;\r\n  border-radius: 12px;\r\n  border: 1px solid #eef2f7;\r\n  height: 120px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.funnel-card p {\r\n  margin: 0;\r\n  font-size: 10px;\r\n  color: #6b7280;\r\n}\r\n\r\n.funnel-card span {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  margin-top: 6px;\r\n}\r\n\r\n.funnel-card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.funnel-card.blue {\r\n  background: #eef4ff;\r\n  border-right: 3px solid #3b82f6;\r\n}\r\n\r\n.funnel-card.orange {\r\n  background: #fff4e5;\r\n  border-right: 3px solid #f59e0b;\r\n}\r\n\r\n.funnel-card.purple {\r\n  background: #f4efff;\r\n  border-right: 3px solid #8b5cf6;\r\n}\r\n\r\n.funnel-card.green {\r\n  background: #edf7ee;\r\n  border-right: 3px solid #10b981;\r\n}\r\n\r\n.funnel-card.red {\r\n  background: #fdecec;\r\n  border-right: 3px solid #ef4444;\r\n}\r\n\r\n.funnel-card span {\r\n  display: block;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  margin-top: 6px;\r\n}\r\n\r\n.funnel-icon {\r\n  margin-top: 10px;\r\n  font-size: 20px;\r\n  opacity: 0.8;\r\n  pointer-events: none;\r\n  padding: 8px;\r\n  border-radius: 100px;\r\n}\r\n\r\n.funnel-icon.blue {\r\n  background: white;\r\n  color: #1d4ed8;\r\n}\r\n\r\n.funnel-icon.orange {\r\n  background: white;\r\n  color: #c2410c;\r\n}\r\n\r\n.funnel-icon.purple {\r\n  background: white;\r\n  color: #6d28d9;\r\n}\r\n\r\n.funnel-icon.green {\r\n  background: white;\r\n  color: #047857;\r\n}\r\n\r\n.funnel-icon.red {\r\n  background: white;\r\n  color: #b91c1c;\r\n}\r\n\r\n.funnel-iconn.blue {\r\n  background: #dbeafe;\r\n  color: #1d4ed8;\r\n  font-size: 20px;\r\n  border-radius: 100px;\r\n  padding: 4px;\r\n}\r\n\r\n.funnel-iconn.orange {\r\n  background: #ffedd5;\r\n  color: #c2410c;\r\n  font-size: 20px;\r\n  border-radius: 100px;\r\n  padding: 4px;\r\n}\r\n\r\n.funnel-iconn.green {\r\n  background: #d1fae5;\r\n  color: #047857;\r\n  font-size: 20px;\r\n  border-radius: 100px;\r\n  padding: 4px;\r\n}\r\n\r\n.funnel-iconn.red {\r\n  width: 25px;\r\n  height: 25px;\r\n  background: white;\r\n  color: #b91c1c;\r\n  font-size: 20px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* .funnel-iconn.red {\r\n  background: white;\r\n  color: #b91c1c;\r\n  font-size: 20px;\r\n  border-radius: 100px;\r\n  padding: 4px;\r\n} */\r\n\r\n.progress-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.progress-bar {\r\n  height: 6px;\r\n  background: #e5e7eb;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  border-radius: 6px;\r\n}\r\n\r\n.metrics-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 2px;\r\n}\r\n\r\n.metric-box {\r\n  background: #f9fafb;\r\n  padding: 6px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 10px;\r\n}\r\n\r\n.metric-box.blue {\r\n  background: #f8fafc;\r\n  border-color: #c7d7fe;\r\n}\r\n\r\n.metric-box.orange {\r\n  background: #f8fafc;\r\n  border-color: #ffd8a8;\r\n}\r\n\r\n.metric-box.green {\r\n  background: #f8fafc;\r\n  border-color: #b7e1c1;\r\n}\r\n\r\n.metric-box.red {\r\n  background: #f8fafc;\r\n  border-color: #f5c2c2;\r\n}\r\n\r\n.metric-box p {\r\n  padding: 0;\r\n  font-size: 10px;\r\n}\r\n\r\n.metric-box strong {\r\n  padding-left: 10px;\r\n  font-size: 16px;\r\n}\r\n\r\n.metric-box.highlight {\r\n  background: #fdecec;\r\n  color: #b91c1c;\r\n}\r\n\r\n.metric-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 100px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 15px;\r\n  background-color: white;\r\n  color: green;\r\n}\r\n\r\n.metric-content {\r\n  padding-left: 0;\r\n}\r\n\r\n.dashboard-main {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1.1fr;\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n  align-items: start;\r\n}\r\n\r\n.left-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.right-panel {\r\n  background: white;\r\n  border-radius: 14px;\r\n  padding: 0;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  /* min-height: 460px;\r\n  height: 460px; */\r\n  height: 320px;\r\n  min-height: 320px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.live-tracking-placeholder {\r\n  height: 100%;\r\n  min-height: 300px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #999;\r\n  font-weight: 500;\r\n}\r\n\r\n.overview-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.funnel-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 20px;\r\n  position: relative;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.funnel-card::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  right: -18px;\r\n  border-left: 6px solid #d1d5db;\r\n  border-top: 4px solid transparent;\r\n  border-bottom: 4px solid transparent;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.funnel-card:last-child::after,\r\n.funnel-card:last-child::before {\r\n  display: none;\r\n}\r\n\r\n.alerts-box {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.alerts-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.alerts-header h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.alerts-header span {\r\n  font-size: 12px;\r\n  color: #3b82f6;\r\n  cursor: pointer;\r\n}\r\n\r\n.alert-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 8px;\r\n  border-radius: 10px;\r\n  transition: 0.2s;\r\n}\r\n\r\n.alert-item:hover {\r\n  background: #f8fafc;\r\n}\r\n\r\n.alert-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.alert-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  margin-right: 8px;\r\n}\r\n\r\n.alert-item p {\r\n  font-size: 12px;\r\n  margin: 0;\r\n}\r\n\r\n.alert-item strong {\r\n  font-size: 12px;\r\n  background: #fee2e2;\r\n  color: #b91c1c;\r\n  padding: 2px 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.alert-dot.red {\r\n  background: #ef4444;\r\n  border-width: 1px;\r\n  border-color: #dc2626;\r\n}\r\n\r\n.alert-dot.blue {\r\n  background: #3b82f6;\r\n  border-width: 1px;\r\n  border-color: #1d4ed8;\r\n}\r\n\r\n.alert-dot.orange {\r\n  background: #ffa200;\r\n  border-width: 1px;\r\n  border-color: #c2410c;\r\n}\r\n\r\n.alert-dot.green {\r\n  background: #10b981;\r\n  border-width: 1px;\r\n  border-color: #059669;\r\n}\r\n\r\n.alert-dot.purple {\r\n  background: #8b5cf6;\r\n  border-width: 1px;\r\n  border-color: #7c3aed;\r\n}\r\n\r\n.alert-dot.yellow {\r\n  background: #f2ff00;\r\n  border-width: 1px;\r\n  border-color: #eab308;\r\n}\r\n\r\n.alert-dot.gray {\r\n  background: #6b7280;\r\n  border-width: 1px;\r\n  border-color: #374151;\r\n}\r\n\r\n.alert-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  margin-left: -10px;\r\n}\r\n\r\n.alert-icon.red {\r\n  background: #fee2e2;\r\n  color: #dc2626;\r\n}\r\n\r\n.alert-icon.orange {\r\n  background: #ffedd5;\r\n  color: #ea580c;\r\n}\r\n\r\n.alert-icon.yellow {\r\n  background: #fef9c3;\r\n  color: #ca8a04;\r\n}\r\n\r\n.alert-icon.green {\r\n  background: #dcfce7;\r\n  color: #16a34a;\r\n}\r\n\r\n.alert-icon.purple {\r\n  background: #ede9fe;\r\n  color: #7c3aed;\r\n}\r\n\r\n.alert-icon.gray {\r\n  background: #f3f4f6;\r\n  color: #4b5563;\r\n}\r\n\r\n.drivers-box {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  align-items: center;\r\n}\r\n\r\n.drivers-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.drivers-header h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.drivers-header span {\r\n  font-size: 12px;\r\n  color: #3b82f6;\r\n  cursor: pointer;\r\n}\r\n\r\n.drivers-box table {\r\n  width: 100%;\r\n  font-size: 12px;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.drivers-box th {\r\n  text-align: center;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  padding: 0 8px;\r\n  border-right: 1px dotted #4b4848;\r\n}\r\n\r\n.drivers-box .successTH {\r\n  border-right: none;\r\n}\r\n\r\n.drivers-box td {\r\n  padding: 10px 0;\r\n  border-top: 1px dotted #4b4848;\r\n}\r\n\r\n.drivers-box .dName {\r\n  text-align: left;\r\n  padding-left: 4px;\r\n}\r\n\r\n.drivers-box .dNumber {\r\n  text-align: right;\r\n  padding-right: 4px;\r\n  border-left: 1px dotted #4b4848;\r\n}\r\n\r\n.drivers-box tr {\r\n  border-bottom: 1px dotted #4b4848;\r\n}\r\n\r\n.drivers-box tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.bottom-grid {\r\n  display: grid;\r\n  grid-template-columns: 1.1fr 2fr 1.9fr;\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.chart-box {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.chart-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.chart-header h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.chart-header span {\r\n  font-size: 12px;\r\n  background: #f1f5f9;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.driver-card {\r\n  background: white;\r\n  padding: 8px 10px;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  font-size: 12px;\r\n  min-width: 120px;\r\n}\r\n\r\n.driver-plate {\r\n  background: #ef4444;\r\n  color: white;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  margin-bottom: 4px;\r\n  text-align: center;\r\n}\r\n\r\n.driver-meta {\r\n  color: #555;\r\n  text-align: center;\r\n}\r\n\r\n.tracking-card {\r\n  height: 100%;\r\n  min-height: 520px;\r\n  background: white;\r\n  border-radius: 24px;\r\n  overflow: hidden;\r\n  border: 1px solid #e5e7eb;\r\n  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.driver-tooltip {\r\n  min-width: 180px;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  background: white;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.driver-tooltip-header {\r\n  padding: 10px 14px;\r\n  font-weight: 700;\r\n  color: white;\r\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\r\n}\r\n\r\n.driver-tooltip-body {\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.driver-tooltip-body div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 13px;\r\n}\r\n\r\n.driver-tooltip-body span {\r\n  color: #6b7280;\r\n}\r\n\r\n.driver-tooltip-body strong {\r\n  color: #111827;\r\n}\r\n\r\n.tracking-header {\r\n  padding: 18px 22px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: white;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.tracking-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n}\r\n\r\n.tracking-header p {\r\n  margin: 4px 0 0;\r\n  color: #64748b;\r\n  font-size: 13px;\r\n}\r\n\r\n.live-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 14px;\r\n  border-radius: 999px;\r\n  background: #dcfce7;\r\n  color: #166534;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.live-badge span {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #22c55e;\r\n}\r\n\r\n/* ── Live Tracking Panel ─────────────────────────────── */\r\n.tracking-header {\r\n  padding: 12px 16px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: white;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  height: 58px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.tracking-header h3 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n}\r\n\r\n.tracking-header p {\r\n  margin: 2px 0 0;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n}\r\n\r\n.live-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 5px 12px;\r\n  border-radius: 999px;\r\n  background: #dcfce7;\r\n  color: #166534;\r\n  font-weight: 700;\r\n  font-size: 11px;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.live-badge span {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #22c55e;\r\n  animation: livePulse 1.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes livePulse {\r\n  0%,\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.4;\r\n    transform: scale(0.8);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
